import { CALLBACK_DOCS } from './callbackDocs';

interface CallbackEditorProps {
  paths: Record<string, string>;
  onChange: (key: string, path: string) => void;
  onOpenDocs: (key: string) => void;
}

export function CallbackEditor({ paths, onChange, onOpenDocs }: CallbackEditorProps) {
  return (
    <div className="space-y-3">
      {CALLBACK_DOCS.map((doc) => {
        const currentPath = paths[doc.key] || doc.defaultPath;
        return (
          <div key={doc.key} className="rounded border border-[var(--co-border)] bg-[var(--co-surface)] p-3">
            {/* Label + Description + Info button */}
            <div className="mb-2 flex items-start justify-between gap-2">
              <div className="flex-1">
                <div className="font-medium text-[var(--co-text)]">{doc.name}</div>
                <div className="text-xs text-[var(--co-muted)]">{doc.description}</div>
              </div>
              <button
                type="button"
                onClick={() => onOpenDocs(doc.key)}
                className="shrink-0 flex h-6 w-6 items-center justify-center rounded-full border border-[var(--co-border)] bg-[var(--co-bg)] text-xs font-semibold text-[var(--co-muted)] hover:bg-[var(--co-border)] focus:outline-none focus:ring-2 focus:ring-[var(--co-brand)]"
                title="View full documentation"
                aria-label={`View documentation for ${doc.name}`}
              >
                ⓘ
              </button>
            </div>

            {/* Path input */}
            <input
              type="text"
              value={currentPath}
              onChange={(e) => onChange(doc.key, e.target.value)}
              placeholder={doc.defaultPath}
              className="w-full rounded border border-[var(--co-border)] bg-[var(--co-bg)] px-2 py-2 font-mono text-sm text-[var(--co-text)] placeholder:text-[var(--co-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--co-brand)]"
            />
          </div>
        );
      })}
    </div>
  );
}
